import { Clock3 } from 'lucide-react';
import { useVoiceSettings, useUpdateVoiceSettings } from '@/hooks/useVoiceApi';

export function formatInactivityMinutes(minutes: number): string {
  return minutes < 60 ? `${minutes} min` : `${minutes / 60} hour${minutes === 60 ? '' : 's'}`;
}

export function InactivityTimeoutControl({ compact = false }: { compact?: boolean }) {
  const { data: settings } = useVoiceSettings();
  const updateSettings = useUpdateVoiceSettings();

  if (!settings) return null;

  return (
    <div className={`flex items-center gap-2 ${compact ? '' : 'justify-center'}`}>
      <Clock3 className="h-4 w-4 shrink-0 text-white/40" aria-hidden="true" />
      <label className="sr-only" htmlFor="inactivity-timeout">Auto-shutdown after inactivity</label>
      <select
        id="inactivity-timeout"
        value={settings.inactivityMinutes}
        onChange={(event) => updateSettings.mutate(Number(event.target.value))}
        disabled={updateSettings.isPending}
        className="cursor-pointer bg-transparent text-xs text-white/60 outline-none disabled:cursor-not-allowed disabled:opacity-50"
      >
        {settings.allowedInactivityMinutes.map((minutes) => (
          <option key={minutes} value={minutes} className="bg-zinc-900 text-white">
            {formatInactivityMinutes(minutes)} inactivity
          </option>
        ))}
      </select>
      {updateSettings.isError && <span className="text-xs text-red-400">Could not save</span>}
    </div>
  );
}